import underline from '@@assets/imgs/infinite_underline.png';
import Image from 'next/image';

const InfiniteUnderline = () => (
  <Image
    src={underline}
    alt="underline"
    loading="lazy"
    draggable={false}
    placeholder="blur"
    unselectable="on"
    quality={100}
    className="pointer-events-none mx-auto h-6 w-auto opacity-75" //
  />
);
export default InfiniteUnderline;
